import { AxiosInstance } from 'axios';

import { CheckInOutRequest } from '@src/types/api/requests/check-in-out-request';

import { TripActionsRepository } from './trip-actions.repository';

export class TripActionsRepositoryAxios implements TripActionsRepository {
  constructor(private readonly axiosInstance: AxiosInstance) {}

  async changeTimes(tripId: string, checkInOutRequest: CheckInOutRequest): Promise<void> {
    await this.axiosInstance.post(`/reservation/v1/${tripId}/change-time`, checkInOutRequest);
  }

  async checkoutReservation(tripId: string) {
    await this.axiosInstance.post(`/reservation/v1/${tripId}/checkout`);
  }
}
